import { Box } from "@material-ui/core";
import { Grid } from "@mui/material";
import { lazy } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import * as Feather from "react-feather";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useHistory } from "react-router";
import MovieSection from "./MovieSection";
import { mainContentStyle } from "./mainContentStyle";
import { useTranslation } from "react-i18next";
import SectionTen from "./SectionTen";
import urls from "../../urls.json";

const ManaCars = lazy(() => import("./MainSections/ManaCars"));
const Banner = lazy(() => import("./MainSections/Banner"));
const Transactions = lazy(() => import("./MainSections/Transactions"));
// const SectionFive = lazy(() => import('./SectionFive'));
const SectionEight = lazy(() => import("./SectionEight"));
const GeneralButton = lazy(
  () => import("../../Utils/GeneralButton/GeneralButton")
);
const Magazins = lazy(() => import("./MainSections/Magazins"));

const MainContent = () => {
  const classes = mainContentStyle();
  const history = useHistory();
  const { t } = useTranslation("mainContent");
  return (
    <>
      <div
        style={{
          backgroundColor: "black",
        }}
      >
        <MovieSection />
        <section
          style={{
            zIndex: 99999,
            minHeight: "max-content",
          }}
        >
          <Box className="row justify-content-center">
            <Grid item lg={12}>
              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                <Box
                  className="row justify-content-center ml-0 mr-0"
                  sx={{
                    marginTop: {
                      xs: "30px",
                      sm: "30px",
                      md: "100px",
                      lg: "100px",
                    },
                  }}
                >
                  <Grid
                    item
                    lg={10}
                    className={classes.gridHeader}
                    style={{ textAlign: "center", color: "white" }}
                  >
                    {t("secExpert")}
                  </Grid>
                </Box>
                <div
                  className="row justify-content-center"
                  style={{
                    marginTop: "50px",
                    maxWidth: "1700px",
                    marginRight: "auto",
                    marginLeft: "auto",
                  }}
                >
                  <Grid item lg={12}>
                    <ManaCars />
                  </Grid>
                </div>
              </ScrollAnimation>
            </Grid>
          </Box>
        </section>
        <section style={{ zIndex: 99999, minHeight: "max-content" }}>
          <Box
            className="row justify-content-center"
            sx={{
              marginTop: { xs: "30px", sm: "30px", md: "100px", lg: "100px" },
            }}
          >
            <Grid item lg={12}>
              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                <Banner />
              </ScrollAnimation>
            </Grid>
          </Box>
        </section>
        {/* <SectionFive /> */}
        <section
          className={classes.section5}
          style={{ minHeight: "max-content", backgroundColor: "white" }}
        >
          <Box
            className="row justify-content-center"
            sx={{
              paddingTop: { xs: "30px", sm: "30px", md: "100px", lg: "100px" },
              paddingBottom: {
                xs: "30px",
                sm: "30px",
                md: "100px",
                lg: "100px",
              },
            }}
          >
            <Grid item lg={12}>
              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                <Box
                  sx={{
                    paddingRight: {
                      xs: "10px",
                      sm: "10px",
                      md: "70px",
                      lg: "70px",
                    },
                    paddingLeft: {
                      xs: "10px",
                      sm: "10px",
                      md: "70px",
                      lg: "70px",
                    },
                    maxWidth: "1700px",
                    marginRight: "auto",
                    marginLeft: "auto",
                  }}
                >
                  <Box
                    className={classes.section5Cntnt}
                    sx={{
                      minHeight: "350px",
                      display: {
                        xs: "block",
                        sm: "block",
                        md: "flex",
                        lg: "flex",
                      },
                      paddingLeft: {
                        xs: "24px",
                        sm: "24px",
                        md: "24px",
                        lg: "24px",
                      },
                      paddingRight: {
                        xs: "24px",
                        sm: "24px",
                        md: "24px",
                        lg: "24px",
                      },
                    }}
                  >
                    <Grid item lg={7} md={12} sm={12} xs={12}>
                      <div className="row justify-content-center w-100 ml-0 mr-0">
                        <Grid item lg={7} md={12} sm={12} xs={12}>
                          <div className="row ml-0 mr-0">
                            <div
                              className={classes.section7Hdr}
                              style={{ textAlign: "center" }}
                            >
                              {t("easySellF")}
                            </div>
                          </div>
                          <div
                            className="row justify-content-center w-100 ml-0 mr-0"
                            style={{ marginTop: "59px" }}
                          >
                            <Grid item lg={11} md={11} sm={12} xs={12}>
                              <div className={classes.section7Text}>
                                {t("easySllExpln")}
                              </div>
                              <div
                                className="row justify-content-start w-100 ml-0 mr-0"
                                style={{
                                  marginTop: "58px",
                                }}
                              >
                                <Grid
                                  item
                                  lg={6}
                                  style={{
                                    textAlign: "center",
                                    marginRight: "auto",
                                    marginLeft: "auto",
                                  }}
                                >
                                  <GeneralButton
                                    className={classes.section4Btn}
                                    clicked={() => {
                                      history.push("/sls-cntnt");
                                    }}
                                    withoutBack
                                    text={
                                      <>
                                        {t("easySellS")}
                                        <Feather.ArrowLeft />
                                      </>
                                    }
                                  />
                                </Grid>
                              </div>
                            </Grid>
                          </div>
                        </Grid>
                      </div>
                    </Grid>
                    <Grid
                      item
                      lg={5}
                      style={{ textAlign: "center", margin: "auto" }}
                      sx={{
                        display: {
                          xs: "block",
                          sm: "block",
                          md: "block",
                          lg: "block",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          marginTop: {
                            xs: "50px",
                            sm: "50px",
                            md: "0",
                            lg: "0",
                          },
                        }}
                        className={classes.iphoneFrame}
                      >
                        <div className={classes.iphoneBg}>
                          <LazyLoadImage
                            className="main-img"
                            width="316"
                            height="381"
                            alt="..."
                            src={
                              process.env.PUBLIC_URL +
                              "/images/easySell-sec.png"
                            }
                            style={{ margin: "auto", width: "100%" }}
                          />
                        </div>
                      </Box>
                    </Grid>
                  </Box>
                </Box>
              </ScrollAnimation>
            </Grid>
          </Box>
        </section>
        <section
          className={classes.section4}
          style={{ minHeight: "max-content", backgroundColor: "white" }}
        >
          <Box
            className="row justify-content-center"
            sx={{
              paddingTop: { xs: "30px", sm: "30px", md: "100px", lg: "100px" },
            }}
          >
            <Grid item lg={12}>
              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                <SectionEight />
              </ScrollAnimation>
            </Grid>
          </Box>
        </section>
        <section style={{ zIndex: 99999, minHeight: "max-content" }}>
          <Box
            className="row justify-content-center"
            sx={{
              marginTop: { xs: "30px", sm: "30px", md: "100px", lg: "100px" },
              maxWidth: "1700px",
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <Grid item lg={12}>
              <Transactions />
            </Grid>
          </Box>
        </section>
        <section
          className={classes.section4}
          style={{ minHeight: "max-content" }}
        >
          <Box
            className="row justify-content-center"
            sx={{
              marginTop: { xs: "30px", sm: "30px", md: "100px", lg: "100px" },
            }}
          >
            <Grid item lg={12}>
              <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                <SectionTen />
              </ScrollAnimation>
            </Grid>
          </Box>
        </section>
      </div>
      <section style={{ minHeight: "max-content" }}>
        <Box className="row justify-content-center">
          <Grid item lg={12}>
            <ScrollAnimation animateOnce={true} animateIn="fadeIn">
              <Box
                sx={{
                  marginTop: {
                    xs: "30px",
                    sm: "30px",
                    md: "140px",
                    lg: "140px",
                  },
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              >
                <div className={classes.facilitySecCntnr}>
                  <Box
                    sx={{
                      maxWidth: "100%",
                    }}
                  >
                    <div className="row justify-content-center w-100 ml-0 mr-0">
                      <div className={classes.secFac1Hdr}>{t("cliclSec")}</div>
                    </div>
                    <Box
                      sx={{
                        paddingRight: {
                          xs: "0",
                          sm: "0",
                        },
                      }}
                      className="row justify-content-center w-100 ml-0 mr-0"
                    >
                      <Grid
                        item
                        lg={7}
                        style={{
                          textAlign: "right",
                          margin: "auto",
                          padding: "0",
                        }}
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Box
                            sx={{
                              marginTop: {
                                xs: "50px",
                                sm: "50px",
                                md: "0",
                                lg: "0",
                              },
                            }}
                            style={{ padding: "0" }}
                          >
                            <div>
                              <LazyLoadImage
                                className="main-img"
                                width="100%"
                                height="100%"
                                alt="..."
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/mainFacilities.jpg"
                                }
                                style={{ margin: "auto" }}
                              />
                            </div>
                          </Box>
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={5}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ margin: "auto", transform: "translateX(25%)" }}
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <div className={classes.secFac2Hdr}>
                            {t("facSec")}
                          </div>
                        </div>
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <div style={{ width: "80%" }}>
                            <div className="row w-100 ml-0 mr-0 mt-4">
                              <div className={classes.facilitySecTxt}>
                                {t("buyExpln")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <Grid
                          item
                          lg={2}
                          style={{
                            marginRight: "60%",
                          }}
                          className={classes.btnFix}
                        >
                          <GeneralButton
                            clicked={() => {
                              history.push("fac-form");
                            }}
                            text={<>{t("facility")}</>}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </div>
              </Box>
            </ScrollAnimation>
          </Grid>
        </Box>
      </section>
      <section
        className={classes.section6}
        style={{ minHeight: "max-content" }}
      >
        <Box className="row justify-content-center">
          <Grid item lg={12}>
            <ScrollAnimation animateOnce={true} animateIn="fadeIn">
              <Box
                sx={{
                  marginTop: {
                    xs: "30px",
                    sm: "30px",
                    md: "140px",
                    lg: "140px",
                  },
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              >
                <div className={classes.section6Cntnr}>
                  <Box
                    sx={{
                      padding: {
                        xs: "32px 24px 93px",
                        sm: "32px 24px 93px",
                        md: "0 129px 0",
                        lg: "0 129px 0",
                      },
                      maxWidth: "1700px",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }}
                  >
                    <Box
                      sx={{
                        paddingRight: {
                          xs: "0",
                          sm: "0",
                          md: "3rem",
                          lg: "3rem",
                        },
                      }}
                      className="row justify-content-center w-100 ml-0 mr-0"
                    >
                      <Grid
                        item
                        lg={6}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ margin: "auto" }}
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <div className={classes.section3Hdr}>
                            {t("sigmaDiff")}
                          </div>
                        </div>
                        <div className="row w-100 ml-0 mr-0">
                          <div
                            style={{
                              width: "10%",
                              textAlign: "left",
                              padding: "0",
                            }}
                          >
                            <div className="row justify-content-end w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                <Feather.CheckCircle
                                  className={classes.check}
                                />
                              </div>
                            </div>
                            <div className="row justify-content-end w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                <Feather.CheckCircle
                                  className={classes.check}
                                />
                              </div>
                            </div>
                            <div className="row justify-content-end w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                <Feather.CheckCircle
                                  className={classes.check}
                                />
                              </div>
                            </div>
                            <div className="row justify-content-end w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                <Feather.CheckCircle
                                  className={classes.check}
                                />
                              </div>
                            </div>
                            <div className="row justify-content-end w-100 ml-0 mr-0 mt-4">
                              <Box
                                sx={{
                                  textAlign: {
                                    xs: "left",
                                    sm: "left",
                                    md: "center",
                                    lg: "center",
                                  },
                                }}
                                className={classes.section3Txt}
                              >
                                <Feather.CheckCircle
                                  className={classes.check}
                                />
                              </Box>
                            </div>
                          </div>
                          <div style={{ width: "90%" }}>
                            <div className="row w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                {t("liquidity")}
                              </div>
                            </div>
                            <div className="row w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                {t("specialized")}
                              </div>
                            </div>
                            <div className="row w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                {t("creditBuy")}
                              </div>
                            </div>
                            <div className="row w-100 ml-0 mr-0 mt-4">
                              <div className={classes.section3Txt}>
                                {t("carReplacement")}
                              </div>
                            </div>
                            <div className="row w-100 ml-0 mr-0 mt-4">
                              <Box
                                sx={{
                                  textAlign: {
                                    xs: "left",
                                    sm: "left",
                                    md: "center",
                                    lg: "center",
                                  },
                                }}
                                className={classes.section3Txt}
                              >
                                {t("carHistory")}
                              </Box>
                            </div>
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        style={{ textAlign: "left", margin: "auto" }}
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Box
                            sx={{
                              marginTop: {
                                xs: "50px",
                                sm: "50px",
                                md: "0",
                                lg: "0",
                              },
                            }}
                            className={classes.hndFrame}
                          >
                            <div className={classes.hndBg}>
                              <LazyLoadImage
                                className="main-img"
                                width="350"
                                height="527"
                                alt="..."
                                src={
                                  process.env.PUBLIC_URL + "/images/sec-6.jpg"
                                }
                                style={{ margin: "auto", width: "100%" }}
                              />
                            </div>
                          </Box>
                        </div>
                      </Grid>
                    </Box>
                  </Box>
                </div>
              </Box>
            </ScrollAnimation>
          </Grid>
        </Box>
      </section>

      {/* <section style={{ minHeight: "max-content" }}>
        <Box className="row justify-content-center">
          <Grid item lg={12}>
            <ScrollAnimation animateOnce={true} animateIn="fadeIn">
              <Box
                sx={{
                  marginTop: {
                    xs: "30px",
                    sm: "30px",
                    md: "140px",
                    lg: "140px",
                  },
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              >
                <div>
                  <Box
                    sx={{
                      maxWidth: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        paddingRight: {
                          xs: "0",
                          sm: "0",
                        },
                      }}
                      className="row justify-content-center w-100 ml-0 mr-0"
                    >
                      <Grid
                        item
                        lg={5}
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.pelakGrid}
                        style={{ flexDirection: "column" }}
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <div className={classes.pelakHeader}>
                            {t("pelasHeader")}
                          </div>
                        </div>
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <div className={classes.pelakSec}>
                            {t("pelakSefidSec")}
                          </div>
                        </div>
                        <Grid item lg={2} className={classes.btnFixPelak}>
                          <a
                            rel="noreferrer"
                            target="_blank"
                            href={urls.pelakSefid}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "nowrap",
                            }}
                          >
                            <div>
                              <LazyLoadImage
                                className="main-img"
                                width="50%"
                                height="50%"
                                alt="..."
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/arrowPelakSec.png"
                                }
                                style={{ margin: "auto" }}
                              />
                            </div>
                            <GeneralButton
                              clicked={() => {}}
                              text={<>{t("pelakSefid")}</>}
                            />
                          </a>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={7}
                        style={
                          {
                            // textAlign: "right",
                            // margin: "auto",
                            // padding: "0",
                          }
                        }
                      >
                        <div className="row justify-content-center w-100 ml-0 mr-0">
                          <Box
                            sx={{
                              marginTop: {
                                xs: "50px",
                                sm: "50px",
                                md: "0",
                                lg: "0",
                              },
                            }}
                            style={{ padding: "0" }}
                          >
                            <div>
                              <LazyLoadImage
                                className="main-img"
                                width="100%"
                                height="100%"
                                alt="..."
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/plksfd-sec.png"
                                }
                                style={{ margin: "auto" }}
                              />
                            </div>
                          </Box>
                        </div>
                      </Grid>
                    </Box>
                  </Box>
                </div>
              </Box>
            </ScrollAnimation>
          </Grid>
        </Box>
      </section> */}

      <section
        className={classes.section6}
        style={{ minHeight: "max-content" }}
      >
        <Box
          className="row justify-content-center"
          sx={{
            marginTop: { xs: "48px", sm: "48px", md: "100px", lg: "100px" },
          }}
        >
          <Grid item lg={12}>
            <ScrollAnimation animateOnce={true} animateIn="fadeIn">
              <Magazins />
            </ScrollAnimation>
          </Grid>
        </Box>
      </section>
    </>
  );
};
export default MainContent;
